import Vue from 'vue'
import moment from "moment"

Vue.filter('dateLL', value => {
     moment.locale('pt')
     return moment(value).format('LL')
})